import(/* webpackMode: "eager" */ "/home/awtinvestments/public_html/app/components/Content.tsx");
;
import(/* webpackMode: "eager" */ "/home/awtinvestments/public_html/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/awtinvestments/public_html/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
